<template>
  <div
    class="image-choice-content"
    :class="{
      'poll-content' : questionImageLayoutMode.length && hasImage,
      'poll-zoom-out': hasImage && questionImageLayoutMode === 'chart',
    }"
    @click.prevent="expandCollapseTrigger('chart')"
  >
    <div
      v-if="questionImageLayoutMode.length && questionImageLayoutMode !== 'image'"
      class="expand-icon"
    >
      <i
        v-if="questionImageLayoutMode !== 'chart'"
        class="fas fa-expand-alt text-2xl text-base-0 pt-1"
        @click.stop="expandCollapseTrigger('chart')"
      ></i>
      <i
        v-if="questionImageLayoutMode === 'chart'"
        class="fas fa-compress-alt text-2xl text-base-0 pt-1"
        @click.stop="expandCollapseTrigger('default')"
      ></i>
    </div>
    <div
      class="box-chart"
      :class="{'chart-white': isTextColourLight}"
      v-show="isChartVisible()"
    >
      <div
        class="vertical layout content-chart"
        :class="getColumnSize(options.length)"
      >
        <div class="flex bar-column horizontal layout">
          <div
            v-for="(item, index) in options"
            :key="index"
            class="flex column-option horizontal layout end"
            :class="{'has-image': hasAtLeastOneSlideOptionImage,
                     'no-image': !hasAtLeastOneSlideOptionImage,
                     'is-correct': slideActive.showCorrectOption && item.correct
                       || !slideActive.showCorrectOption}"
          >
            <div
              class="h-column"
              :style="{height: item.countPercent, opacity: opacityWhenHoverColumn(item.id)}"
              @mouseover="mouseoverColumn(item.id)"
              @mouseleave="mouseLeaveColumn"
              @click.stop="_showChartPercentage()"
            >
              <div
                class="content-column"
                :style="{backgroundColor: item.color}"
                :class="{'no-border': !item.count}"
                v-tooltip="item.tooltipTitle"
              />
              <div class="value-column">
                <span v-if="!$store.state.slideActive.showPercentage">{{ item.count || 0 }}</span>
                <span v-if="$store.state.slideActive.showPercentage">{{ item.percent }}%</span>
              </div>
              <div
                class="image-column"
                v-if="hasAtLeastOneSlideOptionImage"
              >
                <div
                  class="image-cropped-option"
                  :style="{backgroundImage: 'url(' + item.imageCropped + ')'}"
                  v-if="item.imageCropped"
                />
                <div class="relative">
                  <div
                    :style="{
                      'background-color': hasAtLeastOneSlideOptionImage && !item.imageCropped ?
                        slideActive.textColour : 'none',
                      'opacity': hasAtLeastOneSlideOptionImage && !item.imageCropped? 0.2 : 1 }"
                    class="bg-image-column"
                  />
                  <i class="far fa-image fa-3x" v-if="!item.imageCropped" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="line" />
        <div class="label horizontal layout">
          <div
            v-for="(item, index) in options"
            :key="index"
            class="flex label-option"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'
import Constant from '@/constant'
import Util from '@/util'
import { isColorLight } from '@/utils/color.utils'
import Socket from '@/socket'
// api
import SlideApi from '@/api/slide'

export default {
  props: {
    questionImageLayoutMode: {
      type: String,
      default: '',
    },
    hasImage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      hoveringColumnId: null,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      currentUser: (state) => state.currentUser,
      presentation: (state) => state.presentation,
      sharePresentation: (state) => state.sharePresentation,
    }),
    ...mapGetters(['isPresenting', 'isBackstage', 'isTextColourLight']),
    ...mapGetters('presentationAttributeModule', ['presentationColorPalette', 'presentationLighterColorPalette']),

    hasAtLeastOneSlideOptionImage() {
      return this.slideActive.SlideOptions.some((option) => option.imageCropped)
    },
    isPollSlide() {
      const slideTypes = ['multipleChoice', 'imageChoice']
      return slideTypes.includes(this.slideActive.type)
    },
  },
  watch: {
    '$store.state.slideActive': function watchSlideActive() {
      if (this.$store.state.slideActive.type === 'pickAnswer') {
        if (this.$store.getters.isPresenting) {
          if (
            this.$store.state.slideActive.quizStatus == Constant.QuizStatuses.RESULT_SCREEN ||
            this.$store.state.sharePresentation
          ) {
            this.options = this.getData()
          }
          return
        }
      }
      this.options = this.getData()
    },
  },
  mounted() {
    this.options = this.getData(true)
    setTimeout(() => {
      this.options = this.getData()
    }, 300)
    if (this.slideActive.type === 'pickAnswer') {
      if (this.$store.state.sharePresentation) {
        this.$store.state.tempAudienceCount = this.slideActive.multipleCountAnswer
      }
      this.updateSlideActiveAction({
        addCorrectOption: true,
      })

      if (this.$store.state.sharePresentation) {
        this.$store.state.tempAudienceCount = this.$store.state.slideActive.multipleCountAnswer
      }

      if (!this.isPresenting && !this.isBackstage) {
        this.updateSlideActiveAction({
          showCorrectOption: false,
          hideResult: false,
        })
      }
    } else {
      this.$store.state.tempAudienceCount = this.$store.state.slideActive.multipleCountAnswer
    }
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction', 'setSlideActiveAction']),
    mouseoverColumn(id) {
      this.hoveringColumnId = id
    },
    mouseLeaveColumn() {
      this.hoveringColumnId = null
    },
    opacityWhenHoverColumn(id) {
      if (!this.hoveringColumnId) {
        return 1
      }
      return (id === this.hoveringColumnId) ? 1 : 0.5
    },
    _showChartPercentage() {
      if (!this.$store.state.sharePresentation) {
        this.updateSlideActiveAction({
          showPercentage: !this.slideActive.showPercentage,
        })
        this._updateSlide({
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          showPercentage: this.$store.state.slideActive.showPercentage,
        })
      }
    },
    getData(isFirstTime) {
      let maxCount = 0
      const options = []
      const colors = JSON.parse(JSON.stringify(this.presentationColorPalette))
      const slide = this.$store.state.slideActive
      let total = 0

      if (slide.type === 'pickAnswer' && this.$store.state.sharePresentation) {
        slide.showCorrectOption = true
      }

      let limitOption = 30
      if (slide.type == 'pickAnswer') {
        limitOption = 8
      }

      slide.SlideOptions.forEach((item, key) => {
        if (!item.id) return
        if (!item.title && !item.image && !item.imageCropped) return
        if (key < limitOption) {
          if (!item.count) item.count = 0
          if (item.count > maxCount) {
            maxCount = item.count
          }
          total += item.count
          let { count } = item
          if (slide.hideResult) {
            count = 0
          }
          options.push({
            count,
            title: item.title || '',
            color: colors[key],
            boderColor: colors[key],
            id: item.id,
            correct: item.correct,
            imageCropped: item.imageCropped,
            image: item.image,
            percent: 0,
          })
        }
      })

      options.forEach((item, key) => {
        item.tooltipTitle = item.title
        if (!item.count) {
          item.countPercent = `${0}%`
        } else {
          item.countPercent = `${(item.count / maxCount) * 100}%`
          item.percent = Math.round((item.count / total) * 100 * 100) / 100
        }
        let limitText = 120
        if (options.length == 4) {
          limitText = 100
        }
        if (options.length == 5) {
          limitText = 76
        }
        if (options.length == 6) {
          limitText = 60
        }
        if (options.length == 7) {
          limitText = 50
        }
        if (options.length >= 8) {
          limitText = 40
        }
        if (options.length === 2) {
          item.title = this.checkPollHasImageLongText(options, slide, item)
        }
        if (options.length > 2) {
          item.title = this.checkPollHasImageLongText(options, slide, item)
          item.title = Util.truncate(item.title, limitText)
        }

        if (this.$store.state.sharePresentation || slide.type !== 'pickAnswer' || (slide.type === 'pickAnswer' && slide.quizStatus == Constant.QuizStatuses.RESULT_SCREEN && !this.$store.state.sharePresentation)) {
          if (slide.addCorrectOption && slide.showCorrectOption && item.correct) {
            item.title = `✅ ${item.title}`
          }
          if (
            slide.addCorrectOption &&
            slide.showCorrectOption &&
            !item.correct
          ) {
            item.title = `❌ ${item.title}`
            item.color = Util.changeRgbaColor(colors[key])
            item.boderColor = Util.changeRgbaColor(colors[key])
          }
        }

        if (isColorLight(slide.textColour)) {
          item.boderColor = '#ffffff'
        }

        if (isFirstTime) {
          item.countPercent = `${0}%`
        }
      })
      return options
    },
    checkPollHasImageLongText(options, slide, item) {
      if (!item.title) return item.title
      let hasLongText = false
      let limitText = 90
      options.forEach((itemOption) => {
        if (itemOption.title && itemOption.title.length > 100) {
          hasLongText = true
        }
      })
      const isDetectTitle = (options.length === 2 || options.length === 3) &&
        slide.image && slide.image.xLarge && hasLongText
      if (options.length === 3) {
        limitText = 60
      }
      if (isDetectTitle) {
        item.title = Util.truncate(item.title, limitText)
      }
      return item.title
    },

    async _updateSlide(params) {
      if (
        this.$store.state.sharePresentation ||
        this.$store.state.slideActive.type === 'pickAnswer'
      ) {
        return
      }
      this.setSlideActiveAction(this.slideActive)
      params.socketId = Socket.getSocketId()
      this.setSyncLoadingAction(1)
      Util.uploadSlide(
        this.$store.state.slideActive,
        this.$store.state.presentation,
      )
      params.presenting = this.$store.getters.isPresenting

      try {
        await SlideApi.updateSlideById(this.slideActive.id, params)
        Util.mixpanelTracking(
          'Slide',
          'Edit setting',
          'Presenter edit setting show percentage on chart',
        )
        this.setSyncLoadingAction(2)
      } catch (error) {
        Sentry.captureException(error)
        this.setSyncLoadingAction(3)
      }
    },

    isChartVisible() {
      const { slideActive, sharePresentation } = this.$store.state
      const isEditorAndNoImgShown = !this.isPresenting
      const isQuizSharePresentationAndNoImgShown = slideActive.type === 'pickAnswer' && sharePresentation
      const isQuizPresenting = slideActive.type === 'pickAnswer' && this.isPresenting && !sharePresentation
      const isPresentingAndNoImgShown = this.isPollSlide && this.isPresenting
      if (isEditorAndNoImgShown ||
          isQuizPresenting || isQuizSharePresentationAndNoImgShown ||
          isPresentingAndNoImgShown) {
        return true
      }
      return false
    },
    expandCollapseTrigger(val) {
      this.$emit('expandCollapseTrigger', val)
    },
    getColumnSize(length) {
      if (length <= 6) return `column-${length}`
      if (length > 6 && length <= 15) return 'column-medium'
      if (length > 15 && length <= 20) return 'column-small'
      if (length > 20 && length <= 30) return 'column-xs'
      return 'column-medium'
    },
  },
}
</script>
<style lang="scss" scoped>
.expand-icon {
  @apply ml-auto w-10 h-10 text-center absolute rounded top-12 right-12 cursor-pointer;
  background-color: #ffffff;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.12));
  opacity: 0;
  z-index: 10;

  i {
    @apply text-base-100;
  }
  &:hover {
    i {
      @apply text-primary-100;
    }
  }
}
.poll-zoom-out {
  cursor: zoom-out !important;
}
.image-cropped-option {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 9;
}
.image-choice-content {
  padding: 0 32px 6px 32px;
  width: 100%;
  height: 100%;
}

.poll-content {
  &:hover {
    background: rgba(209, 209, 209, 0.2);
    .expand-icon {
      opacity: 1;
    }
  }
}

.bg-image-column {
  position: absolute;
  width: 100%;
  height: 100%;
}
.box-chart,
.content-chart {
  width: 100%;
  height: 100%;
}
.line {
  border-top: 1px solid #313131;
  margin-bottom: 8px;
}
.label-option {
  text-align: center;
  padding: 0 8px;
  font-weight: normal;
  line-height: 1.3;
}
.image-column {
  height: 100px;
  position: absolute;
  top: -100px;
  left: 0;
  width: 100%;
  border: 1px solid #ffffff;
  border-bottom: 0;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;

  img {
    width: auto;
    max-width: 100%;
    max-height: 100%;
    position: relative;
  }
  .relative {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
  }

  .fa-image {
    opacity: 0.5;
    position: absolute;
    top: 50%;
    margin-top: -25px;
    left: 50%;
    margin-left: -28px;
  }
}

.h-column {
  width: 100px;
  margin: 0 auto;
  border-bottom: 0;
  position: relative;
  cursor: pointer;
  transition: 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

  &:hover {
    opacity: 0.9;
  }
}
.content-column {
  width: 100%;
  height: 100%;
  border: 1px solid #fff;
  border-bottom: 0;
  &.no-border {
    border: none;
  }
}
.column-option {
  position: relative;
  padding-top: 48px;
  transition: 0.5s ease-in-out;
  &.no-image {
    .content-column {
      border-top: 0;
    }
    .fa-image {
      display: none;
    }
  }
  .value-column {
    position: absolute;
    top: -48px;
    left: 0;
    width: 100%;
    font-size: 23px;
    text-align: center;
    margin-top: 13px;
  }
}
.column-2,
.column-1,
.column-3,
.column-4,
.column-5,
.column-6 {
  .h-column {
    width: 120px;
  }

  .image-column {
    height: 120px;
    top: -120px;
  }

  .no-image.is-correct {
    .image-column {
      height: 121px;
    }
  }

  .column-option {
    padding-top: 168px;
    &.has-image {
      .value-column {
        top: -168px;
      }
    }
  }
}

.column-7, .column-8, .column-9 {
  .h-column {
    width: 116px;
  }
  .image-column {
    height: 116px;
    top: -116px;
  }
  .no-image.is-correct {
    .image-column {
      height: 117px;
    }
  }
  .column-option {
    padding-top: 164px;
    &.has-image {
      .value-column {
        top: -164px;
        font-size: 21px;
      }
    }
  }
}

.column-medium {
  .h-column {
    width: 90%;
  }
  .image-column {
    height: 90px;
    top: -90px;
  }
  .no-image.is-correct {
    .image-column {
      height: 91px;
    }
  }
  .column-option {
    padding-top: 140px;
    &.has-image {
      padding-top: 230px;
      .value-column {
        top: -135px;
      }
    }
  }
  .value-column {
    top: -45px;
    font-size: 19px;
  }
  .label-option {
    font-size: 13px;
    padding: 0;
  }
}

.column-small {
  .h-column {
    width: 85%;
  }
  .image-column {
    height: 55px;
    top: -55px;
  }
  .no-image.is-correct {
    .image-column {
      height: 56px;
    }
  }
  .column-option {
    padding-top: 100px;
    &.has-image {
      padding-top: 155px;
      .value-column {
        top: -95px;
      }
    }
  }
  .value-column {
    top: -40px;
    font-size: 15px;
  }
  .label-option {
    font-size: 10px;
    padding: 0;
  }
}

.column-xs {
  .h-column {
    width: 85%;
  }
  .image-column {
    height: 40px;
    top: -40px;
  }
  .no-image.is-correct {
    .image-column {
      height: 41px;
    }
  }
  .column-option {
    padding-top: 85px;
    &.has-image {
      padding-top: 125px;
      .value-column {
        top: -70px;
      }
    }
  }
  .value-column {
    top: -30px;
    font-size: 10px;
  }
  .label-option {
    font-size: 6px;
    padding: 0;
  }
}

.chart-white {
  .line {
    border-color: #fff;
    overflow: hidden;
  }
}

//Set font size (same as bar chart)
.column-1,
.column-2,
.column-3 {
  .label-option {
    font-size: 26px;
  }
}

.column-4 .label-option {
  font-size: 22px;
}

.column-5, .column-6, .column-7, .column-8, .column-9 {
  .label-option {
    font-size: 19px;
  }
}

</style>
